import React from 'react';
import PropTypes from 'prop-types';

const shimmerKeyframes = `
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
`;

// Inject keyframes once at module load time to avoid duplicating <style> tags on every render
if (typeof document !== 'undefined' && !document.querySelector('shimmer-keyframes')) {
  const style = document.createElement('style');
  style.id = 'shimmer-keyframes';
  style.textContent = shimmerKeyframes;
  document.head.appendChild(style);
}

const ShimmerLoader = ({
  height = '40px', width = '100%', borderRadius = '4px', className = 'col-md-12',
}) => (
  <div
    role="status"
    aria-busy={true}
    aria-label="Loading"
    className={className}
    style={{
      height,
      width,
      borderRadius,
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s infinite ease-in-out',
    }}
  />
);

ShimmerLoader.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  borderRadius: PropTypes.string,
  className: PropTypes.string,
};

export default ShimmerLoader;
